import { media } from '@atlaskit/primitives/responsive';
import { token } from '@atlaskit/tokens';
import { styled } from '@compiled/react';
import React from 'react';
import { Link } from 'react-router-dom';

import { Text } from './Button.styles';

const MenuLinkMobileStyled = styled(Link)({
  display: 'flex',
  alignItems: 'center',
  backgroundColor: token('color.background.neutral.subtle'),
  cursor: 'pointer',
  color: token('color.text.subtle'),
  borderRadius: '3px',
  border: 'none',
  whiteSpace: 'nowrap',
  padding: `${token('space.0')} ${token('space.300')}`,
  gap: token('space.100'),
  height: '56px',
  width: '100%',
  justifyContent: 'start',
  textDecoration: 'none',

  '&:hover': {
    backgroundColor: token('color.background.neutral.subtle.hovered'),
    textDecoration: 'none',
  },
  '&:active': {
    backgroundColor: token('color.background.neutral.subtle.pressed'),
  },
  '&:focus-visible': {
    outline: `2px solid ${token('color.border.focused')}`,
  },
  [media.above.xs]: {
    padding: `${token('space.0')} ${token('space.400')}`,
  },
  [media.above.sm]: {
    padding: `${token('space.0')} ${token('space.500')}`,
  },
});

const Separator = styled.div({
  borderBottom: `1px solid ${token('color.border')}`,
});

interface MenuLinkMobileProps {
  to: string;
  label: string;
  onClick?: () => void;
}

export const MenuLinkMobile = ({ to, label, onClick }: MenuLinkMobileProps) => {
  return (
    <div>
      <MenuLinkMobileStyled to={to} aria-label={label} onClick={onClick}>
        <Text>{label}</Text>
      </MenuLinkMobileStyled>
      <Separator />
    </div>
  );
};
